import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-667cb5c8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "accounts-container"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "header-filters" }
const _hoisted_4 = { class: "header-filters-search" }
const _hoisted_5 = { class: "p-input-icon-left" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1))
const _hoisted_7 = {
  key: 0,
  class: "selected-account-actions"
}
const _hoisted_8 = { class: "crud-actions" }
const _hoisted_9 = { class: "crud-actions" }
const _hoisted_10 = { class: "crud-actions" }
const _hoisted_11 = { class: "crud-actions" }
const _hoisted_12 = { class: "admin-actions" }
const _hoisted_13 = { class: "defaults" }
const _hoisted_14 = { class: "defaults" }
const _hoisted_15 = { class: "lm-table-row-actions" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 1,
  class: "accounts-container"
}
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { class: "header-filters" }
const _hoisted_20 = {
  key: 0,
  class: "selected-account-actions"
}
const _hoisted_21 = { class: "crud-actions" }
const _hoisted_22 = { class: "lm-table-row-actions" }
const _hoisted_23 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Button = _resolveComponent("Button")!
  const _component_ConfirmPopup = _resolveComponent("ConfirmPopup")!
  const _component_Column = _resolveComponent("Column")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_CreateUpdateAccount = _resolveComponent("CreateUpdateAccount")!
  const _component_PushToPipedrive = _resolveComponent("PushToPipedrive")!
  const _component_ModalComponent = _resolveComponent("ModalComponent")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.accountStore.isAdmin || _ctx.accountStore.isEmployee)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createVNode(_component_DataTable, {
                dataKey: "id",
                class: "accounts-datatable",
                scrollHeight: "flex",
                stripedRows: "",
                selectionMode: "single",
                selection: _ctx.selectedAccount,
                "onUpdate:selection": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                stateKey: "accounts-table-state",
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                rowsPerPageOptions: [10, 25, 50, 100],
                scrollable: true,
                rowClass: _ctx.rowClass,
                value: _ctx.items,
                paginator: true,
                rows: _ctx.rows,
                totalRecords: _ctx.totalRecords,
                filters: _ctx.filters,
                "onUpdate:filters": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters) = $event)),
                loading: _ctx.loading,
                globalFilterFields: _ctx.globalFilter,
                filterDisplay: "row",
                onRowDblclick: _ctx.accountDblClicked
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                      _createElementVNode("span", _hoisted_5, [
                        _hoisted_6,
                        _createVNode(_component_InputText, {
                          modelValue: _ctx.filters['global'].value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters['global'].value) = $event)),
                          placeholder: "Keyword Search"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    (_ctx.selectedAccount && _ctx.selectedAccount.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createVNode(_component_Button, {
                              disabled: !_ctx.selectedAccount.id,
                              label: "Modify Account",
                              onClick: _ctx.modifyAccount,
                              class: "p-button-success p-button-outlined"
                            }, null, 8, ["disabled", "onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                              _createVNode(_component_Button, {
                                label: _ctx.deleteLabel,
                                disabled: _ctx.invalidAccountsFormToDelete,
                                class: "p-button-danger p-button-outlined",
                                onClick: _ctx.deleteAccount
                              }, null, 8, ["label", "disabled", "onClick"]),
                              _createVNode(_component_ConfirmPopup)
                            ])), [
                              [_directive_tooltip, 'You can only delete one account at a time and you can not delete your account.']
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_10, [
                            _createVNode(_component_Button, {
                              disabled: !_ctx.selectedAccount.id,
                              label: "Manage licenses",
                              class: "p-button-secondary p-button-outlined",
                              onClick: _ctx.manageLicenses
                            }, null, 8, ["disabled", "onClick"])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_Button, {
                              disabled: !_ctx.selectedAccount.id,
                              label: "Push to Pipedrive",
                              class: "p-button-secondary p-button-outlined",
                              onClick: _ctx.pushToPipedrive
                            }, null, 8, ["disabled", "onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_Button, {
                          label: "Add",
                          class: "p-button-success p-button-outlined",
                          onClick: _ctx.createAccount
                        }, null, 8, ["onClick"])
                      ]),
                      _createElementVNode("div", _hoisted_14, [
                        _createVNode(_component_Button, {
                          label: "Export",
                          class: "p-button-secondary p-button-outlined",
                          onClick: _ctx.exportAccounts
                        }, null, 8, ["onClick"])
                      ])
                    ])
                  ])
                ]),
                empty: _withCtx(() => [
                  _createTextVNode("No accounts found.")
                ]),
                loading: _withCtx(() => [
                  _createTextVNode("Loading accounts. Please wait.")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Actions",
                    headerStyle: "padding-left: 18px;",
                    style: {"min-width":"10rem","max-width":"10rem"},
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_15, [
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-pencil",
                            onClick: ($event: any) => (_ctx.modifyAccountFromGrid(data)),
                            class: "p-button-rounded p-button-outlined p-button-success"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Edit Account']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-trash",
                            disabled: _ctx.invalidAccountToDeleteFromGrid(data),
                            onClick: ($event: any) => (_ctx.deleteAccountFromGrid(data, $event)),
                            class: "p-button-rounded p-button-outlined p-button-danger"
                          }, null, 8, ["disabled", "onClick"])
                        ])), [
                          [_directive_tooltip, 'Delete Account']
                        ]),
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-file-export",
                            onClick: ($event: any) => (_ctx.exportAccount(data)),
                            class: "p-button-rounded p-button-outlined p-button-secondary"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Export Account']
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "company",
                    header: "Company",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("b", null, _toDisplayString(data.company), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by company"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "salutation",
                    header: "Salutation",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.salutation), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by salutation"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "name",
                    header: "Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.name), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by name"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "surname",
                    header: "Surname",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.surname), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by surname"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "email",
                    header: "Email",
                    sortable: "",
                    "show-filter-menu": false,
                    style: {"min-width":"20rem","overflow-wrap":"break-word"}
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.email), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by email"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "emailConfirmed",
                    header: "Mail Validated",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.emailConfirmed ? 'Yes' : 'No'), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_MultiSelect, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        options: _ctx.emailConfirmedOptions,
                        optionLabel: "label",
                        optionValue: "value",
                        placeholder: "Any",
                        showClear: true,
                        maxSelectedLabels: 2,
                        onChange: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "role",
                    header: "Type",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.role), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_MultiSelect, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        options: _ctx.roleFilterOptions,
                        placeholder: "Any",
                        showClear: true,
                        maxSelectedLabels: 1,
                        onChange: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "createdDate",
                    header: "Creation Date",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.createdDate.toDateString()), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_Calendar, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        selectionMode: "range",
                        manualInput: false,
                        placeholder: "From – To",
                        showButtonBar: true,
                        onHide: ($event: any) => (filterCallback()),
                        onClearClick: ($event: any) => (filterCallback())
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onHide", "onClearClick"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["selection", "rowClass", "value", "rows", "totalRecords", "filters", "loading", "globalFilterFields", "onRowDblclick"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_16, [
              _createVNode(_component_CreateUpdateAccount, {
                account: _ctx.account,
                onCreated: _ctx.processCreateAccount,
                onUpdated: _ctx.processUpdateAccount,
                onReactivated: _ctx.processReactivateAccount,
                onCancel: _ctx.processCancel
              }, null, 8, ["account", "onCreated", "onUpdated", "onReactivated", "onCancel"])
            ])),
        _createVNode(_component_ModalComponent, { open: _ctx.showPipedriveModal }, {
          body: _withCtx(() => [
            _createVNode(_component_PushToPipedrive, {
              account: _ctx.selectedAccount,
              onCancel: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPipedriveModal = false)),
              onClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showPipedriveModal = false))
            }, null, 8, ["account"])
          ]),
          _: 1
        }, 8, ["open"])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        (!_ctx.showModal)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createVNode(_component_DataTable, {
                dataKey: "id",
                class: "accounts-datatable",
                scrollHeight: "flex",
                stripedRows: "",
                selectionMode: "single",
                selection: _ctx.selectedAccount,
                "onUpdate:selection": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedAccount) = $event)),
                stateKey: "accounts-table-state",
                scrollable: true,
                rowClass: _ctx.rowClass,
                value: _ctx.items,
                rows: _ctx.rows,
                totalRecords: _ctx.totalRecords,
                filters: _ctx.filters,
                "onUpdate:filters": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters) = $event)),
                loading: _ctx.loading,
                globalFilterFields: _ctx.globalFilter,
                filterDisplay: "row",
                currentPageReportTemplate: "Showing {first} to {last} of {totalRecords} entries",
                paginatorTemplate: "FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown",
                rowsPerPageOptions: [10, 25, 50, 100],
                paginator: true
              }, {
                header: _withCtx(() => [
                  _createElementVNode("div", _hoisted_19, [
                    (_ctx.selectedAccount && _ctx.selectedAccount.id)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_Button, {
                              disabled: !_ctx.selectedAccount.id,
                              label: "Modify Account",
                              onClick: _ctx.modifyAccount,
                              class: "p-button-success p-button-outlined"
                            }, null, 8, ["disabled", "onClick"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                empty: _withCtx(() => [
                  _createTextVNode("No accounts found.")
                ]),
                loading: _withCtx(() => [
                  _createTextVNode("Loading accounts. Please wait.")
                ]),
                default: _withCtx(() => [
                  _createVNode(_component_Column, {
                    header: "Actions",
                    headerStyle: "padding-left: 18px;",
                    style: {"min-width":"10rem","max-width":"10rem"},
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("div", _hoisted_22, [
                        _withDirectives((_openBlock(), _createElementBlock("div", null, [
                          _createVNode(_component_Button, {
                            type: "button",
                            icon: "pi pi-pencil",
                            onClick: ($event: any) => (_ctx.modifyAccountFromGrid(data)),
                            class: "p-button-rounded p-button-outlined p-button-success"
                          }, null, 8, ["onClick"])
                        ])), [
                          [_directive_tooltip, 'Edit Account']
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "company",
                    header: "Company",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createElementVNode("b", null, _toDisplayString(data.company), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by company"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "salutation",
                    header: "Salutation",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.salutation), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by salutation"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "name",
                    header: "Name",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.name), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by name"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "surname",
                    header: "Surname",
                    sortable: "",
                    "show-filter-menu": false
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.surname), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by surname"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_Column, {
                    field: "email",
                    header: "Email",
                    sortable: "",
                    "show-filter-menu": false,
                    style: {"min-width":"20rem","overflow-wrap":"break-word"}
                  }, {
                    body: _withCtx(({ data }) => [
                      _createTextVNode(_toDisplayString(data.email), 1)
                    ]),
                    filter: _withCtx(({ filterModel, filterCallback }) => [
                      _createVNode(_component_InputText, {
                        modelValue: filterModel.value,
                        "onUpdate:modelValue": ($event: any) => ((filterModel.value) = $event),
                        onInput: ($event: any) => (filterCallback()),
                        placeholder: "Filter by email"
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "onInput"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["selection", "rowClass", "value", "rows", "totalRecords", "filters", "loading", "globalFilterFields"])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _createVNode(_component_CreateUpdateAccount, {
                account: _ctx.account,
                onCreated: _ctx.processCreateAccount,
                onUpdated: _ctx.processUpdateAccount,
                onReactivated: _ctx.processReactivateAccount,
                onCancel: _ctx.processCancel
              }, null, 8, ["account", "onCreated", "onUpdated", "onReactivated", "onCancel"])
            ]))
      ]))
}